import {BlogFeatured} from './newscomponent/BlogFeatured'
import {BlogList} from './newscomponent/BlogList';
export const News = ()=>{
  return(
    <>
    <BlogFeatured/>
    <BlogList/>
    </>
  )
}